import React, { useState } from 'react';
import { Button, TextField, Box, Typography, Container, Paper, CircularProgress, Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import FetchService from '../../services/FetchService';
import endpoints from '../../environment/endpoints';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const fetchService = new FetchService();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsLoading(true);

    const res = await fetchService.post(endpoints.forgotPassword, { email });
    if (res.success) {
      setMessage('If that account exists, a reset link has been dispatched.');
    } else {
      setError(res.data?.message || res.errors || 'An error occurred.');
    }
    setIsLoading(false);
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 4, marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h4" gutterBottom fontWeight="bold" color="secondary">
          Forgot Password
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
          Enter your email to receive a password reset link.
        </Typography>

        {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
        {message && <Alert severity="success" sx={{ width: '100%', mb: 2 }}>{message}</Alert>}

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            disabled={isLoading}
            sx={{ mt: 3, mb: 2, padding: 1.5, fontSize: '1.1rem' }}
          >
            {isLoading ? <CircularProgress size={24} /> : 'Send Reset Link'}
          </Button>
          
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography variant="body2">
              <Link to="/login" style={{ color: '#FF3900', textDecoration: 'none', fontWeight: 'bold' }}>
                Back to Login
              </Link>
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}
